import { ABOUT_ME_BIO } from '../constants';

export const aboutMeBioHeader = state => {
    const teamMembers = state.profile.team_members || [];

    return teamMembers.length
        ? aboutMeBioTeamHeader(state)
        : aboutMeBioIndividualHeader(state);
};

export const aboutMeBioBody = state => {
    return state.profile.about_me_bio
        || state.theme_data.about_page.empty_state_text
        || state.theme_data.about_page.team_empty_state_text
        || '';
};

const aboutMeBioIndividualHeader = state => {
    if (state.theme_data.labels && state.theme_data.labels.about_header_single) {
        return state.theme_data.labels.about_header_single;
    }

    return ABOUT_ME_BIO.ABOUT_ME_HEADERS.ABOUT_ME;
};

const aboutMeBioTeamHeader = state => {
    if (state.theme_data.labels && state.theme_data.labels.about_header_multiple) {
        return state.theme_data.labels.about_header_multiple;
    }

    return ABOUT_ME_BIO.ABOUT_ME_HEADERS.ABOUT_US;
};



// WEBPACK FOOTER //
// ./components/aboutmebio/selectors.js